import { Component, OnInit, Inject } from '@angular/core';
import { TokenMaquinaModel } from 'src/app/model/cadastra-maquina.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DownloadService } from 'src/app/services/download.service';

@Component({
  selector: 'app-modal-salva-token-usuario',
  templateUrl: './modal-salva-token-usuario.component.html',
  styleUrls: ['./modal-salva-token-usuario.component.css']
})
export class ModalSalvaTokenUsuarioComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalSalvaTokenUsuarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private downloadService: DownloadService,
  ) { }

  ngOnInit() {

  }

  baixarToken() {
    const tokenModel = new TokenMaquinaModel();
    tokenModel.key = this.data.inscricao;
    tokenModel.jwt = window.localStorage.getItem(this.data.inscricao);
    const nomeToken = 'token'.concat(this.data.inscricao);
    this.downloadService.efetuaDownload(JSON.stringify(tokenModel), nomeToken.concat('.txt'), 'application/txt');
    this.dialogRef.close();

  }
}
